// 应收账款（与业务管理同级，对应流程「应收账款上链」阶段）
export default {
  title: '应收账款',
  type: 'folder',
  name: Symbol('receivable'),
  route: '/receivable',
  inNav: true,
  icon: 'iconfont icon-zhangkuan',
  isElementIcon: false,
  order: 3,
  userTypes: ['SUPER_ADMIN', 'BRAND_OWNER', 'SUPPLIER'],
  children: [
    {
      title: '应收账款列表',
      type: 'view',
      name: Symbol('receivable-list'),
      route: '/receivable/list',
      filePath: 'view/business/account-receivable/list.vue',
      inNav: true,
      icon: 'iconfont icon-zhangkuan',
      isElementIcon: false,
      userTypes: ['SUPER_ADMIN', 'BRAND_OWNER', 'SUPPLIER'],
    },
    {
      title: '应收账款上链申请',
      type: 'view',
      name: Symbol('receivable-onchain-apply'),
      route: '/receivable/onchain-apply',
      filePath: 'view/receivable/onchain-apply.vue',
      inNav: true,
      icon: 'iconfont icon-tijiao',
      isElementIcon: false,
      userTypes: ['SUPER_ADMIN', 'BRAND_OWNER', 'SUPPLIER'],
    },
  ],
}
